<template>
  <div>
    <SidebarLink v-if="item.type === 'link'" :item="item"/>

    <div v-if="item.type === 'collapse'">

      <div class="mx-1 flex items-center px-6 py-2 mt-4 duration-200 cursor-pointer"
           :class="[isActive(item) ?
         'bg-gray-600 bg-opacity-25 text-gray-100 border-l-4 border-gray-100' :
         'border-l border-gray-500 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100']"
           @click="collapseOpen = !collapseOpen">
        <component :is="item.icon" class="flex-shrink-0 w-5 h-5"/>

        <div class="mx-4">{{ item.title }}</div>

        <ChevronUpIcon v-if="collapseOpen" class="flex-shrink-0 w-5 h-5"/>
        <ChevronDownIcon v-else class="flex-shrink-0 w-5 h-5"/>
      </div>
      <transition
          enter-active-class="transition-[height] duration-150 ease-linear"
          enter-from-class="max-h-0"
          enter-to-class="max-h-screen"
          leave-active-class="transition-[height] duration-150 ease-linear"
          leave-from-class="max-h-screen"
          leave-to-class="max-h-0"
      >
        <div v-show="collapseOpen" class="pl-4">
          <SidebarItem v-for="(item, index) in item.children" :key="index" :item="item"/>
        </div>
      </transition>

    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink';

export default {
  name: 'SidebarItem',
  props: {
    item: Object
  },
  components: {
    SidebarLink
  },
  data() {
    return {
      collapseOpen: false,
    }
  },
  mounted() {
    this.initCollapseOpen()
  },
  methods: {
    isActive(item) {
      let has = false
      if(item.type === 'link') {
        if(item.route === this.$route.name) {
          has = true
        }
      } else {
        for (let i = 0; i < item.children.length; i++) {
          if(this.isActive(item.children[i])) {
            has = true
            break
          }
        }
      }
      return has
    },
    initCollapseOpen() {
      if(this.item.type === 'collapse') {
        this.collapseOpen = this.isActive(this.item)
      }
    }
  }
}
</script>